import { Box, Typography } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import { Direction } from './dashboardComparisonUtils';

type ComparisonBadgeProps = {
  percentage: number;
  direction: Direction;
  label: string;
  isNew?: boolean;
};

const config = {
  up: { color: 'primary.main', bg: 'primary.light', Icon: TrendingUpIcon },
  down: { color: 'error.main', bg: 'error.light', Icon: TrendingDownIcon },
  neutral: { color: 'text.secondary', bg: 'background.default', Icon: TrendingFlatIcon },
};

export const ComparisonBadge = ({ percentage, direction, label, isNew }: ComparisonBadgeProps) => {
  const { color, bg, Icon } = config[direction];

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        px: 1,
        py: 0.25,
        borderRadius: '4px',
        backgroundColor: bg,
      }}>
      <Icon sx={{ fontSize: 14, color }} />
      <Typography
        variant="caption"
        sx={{ color, fontWeight: 600, whiteSpace: 'nowrap', direction: 'ltr', fontVariantNumeric: 'tabular-nums' }}>
        {isNew ? 'New' : `${percentage > 0 ? '+' : ''}${percentage}%`} {label}
      </Typography>
    </Box>
  );
};
